/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('LogonWorkflow.KickExistingSession', {
  Instructions: 'You are about to interrupt an active session already in progress with the same username.',
  Warning: 'If you believe the other session is not authorized, please contact Customer Support at {contact} immediately.'
});
